var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 30,
    viewBox: "0 0 18 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3334 9.89692C17.8783 9.35199 17.8783 8.47804 17.3334 7.93311L9.98197 0.581679C9.72492 0.324636 9.36506 0.17041 9.0052 0.17041C8.64534 0.17041 8.28548 0.314354 8.02844 0.581679L0.677009 7.93311C0.132078 8.47804 0.132078 9.35199 0.677009 9.89692C0.944334 10.1642 1.30419 10.3082 1.65377 10.3082C2.00335 10.3082 2.36321 10.1745 2.63054 9.89692L7.61717 4.91028V27.8282C7.61717 28.5994 8.23407 29.2163 9.0052 29.2163C9.77633 29.2163 10.3932 28.5994 10.3932 27.8282V4.91028L15.3799 9.89692C15.9145 10.4418 16.7885 10.4418 17.3334 9.89692Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadArrow);
export default __webpack_public_path__ + "static/media/upload_arrow.23be346b1f6534bddd030984a0707b8e.svg";
export { ForwardRef as ReactComponent };